import { jwtDecode } from 'jwt-decode';

// Check if token is expired
export const isTokenExpired = (token) => {
  try {
    const decodedToken = jwtDecode(token); // Decode the token
    const currentTime = Date.now() / 1000; // Get current time in seconds
    //console.log('decodedToken:', decodedToken)
    // Check if the current time is past the token's expiration time
    if (decodedToken.exp < currentTime) {
      return true; // Token has expired
    }

    return false; // Token is still valid
  } catch (error) {
    return true; // If decoding fails, consider it expired
  }
};

// Get the JWT token from localStorage
export const getToken = () => {
  return localStorage.getItem('authToken');
};

export const decodeToken = (token, key) => {
  try {
    // Decode the token
    if (!token) return null;

    const decodedToken = jwtDecode(token);

    //console.log(key,':',decodedToken[key])
    // Access the user_id (or the specific claim you're looking for)
    return decodedToken[key]; // Adjust this key based on your token structure
  } catch (error) {
    console.error('token:', token, ', Invalid token', error);
    removeToken();
    //window.location.href = '/login/user-login';
    return null;
  }
};

// Remove the JWT token from localStorage
export const removeToken = () => {
  localStorage.removeItem('authToken');
};
